import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#2d1200] py-12" dir="rtl" role="contentinfo" aria-label="כותרת תחתונה">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/7be8eb09dc6daa3388afff0d207e476a.jpeg"
                alt="לוגו Meet n' Meat"
                className="w-12 h-12 rounded-full object-cover"
                width="48"
                height="48"
              />
              <span
                className="text-white font-bold text-xl"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                Meet n&apos; Meat
              </span>
            </div>
            <p
              className="text-white/50 text-sm leading-relaxed"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              פוד טראק בשרים מקצועי של ליאור לז&apos;רוביץ.
              <br />
              מביאים את חוויית הבשרים המעושנים ישירות לאירוע שלכם.
            </p>
          </div>

          {/* Nav */}
          <nav aria-label="ניווט מהיר - כותרת תחתונה">
            <h4
              className="text-white font-bold text-base mb-4"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              ניווט מהיר
            </h4>
            <ul className="flex flex-col gap-2 list-none p-0 m-0">
              {[
                { label: "בית", path: "/" },
                { label: "אודות", path: "/about" },
                { label: "התפריט", path: "/menu" },
                { label: "אירועים", path: "/events" },
                { label: "גלריה", path: "/gallery" },
                { label: "הצהרת נגישות", path: "/accessibility" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/50 hover:text-[#e85d04] text-sm transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Social */}
          <div>
            <h4
              className="text-white font-bold text-base mb-4"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              עקבו אחרינו
            </h4>
            <ul className="flex flex-col gap-3 list-none p-0 m-0">
              <li>
                <a
                  href="https://www.instagram.com/meet_n_meatoffical/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/50 hover:text-[#e85d04] text-sm transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                  aria-label="עמוד האינסטגרם שלנו (נפתח בחלון חדש)"
                >
                  <div className="w-6 h-6 flex items-center justify-center" aria-hidden="true">
                    <i className="ri-instagram-fill" aria-hidden="true"></i>
                  </div>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/972542465614"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/50 hover:text-[#25d366] text-sm transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                  aria-label="צרו קשר בוואטסאפ (נפתח בחלון חדש)"
                >
                  <div className="w-6 h-6 flex items-center justify-center" aria-hidden="true">
                    <i className="ri-whatsapp-fill" aria-hidden="true"></i>
                  </div>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <p
            className="text-white/30 text-xs"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            &copy; 2026 Meet n&apos; Meat - ליאור לז&apos;רוביץ. כל הזכויות שמורות.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
